// agent唯一标识
export enum AgentUnionCode {
    /**
     * 技术方案探索
     */
    eureka_rd_ai_agent_find_solution = 'eureka_rd_ai_agent_find_solution', // mind
    /**
     * 技术方案探索material
    */
    eureka_ai_agent_find_solution_material = 'eureka_ai_agent_find_solution_material',
    /**
     * 技术方案探索material v2 版本
    */
    eureka_ai_agent_find_solution_material_v2 = 'eureka_ai_agent_find_solution_material_v2',
    /**
     * 技术方案探索material
     */
    eureka_rd_ai_agent_material_find_solution = 'eureka_rd_ai_agent_material_find_solution',
    /**
     * 技术问答
     */
    eureka_rd_ai_agent_technical_qa = 'eureka_rd_ai_agent_technical_qa', // seek
    /**
     * 可行性分析助手
     */
    eureka_rd_ai_agent_validation = 'eureka_rd_ai_agent_validation',
    /**
     * 金属材料解析
     */
    eureka_mse_metal_agent_validation = 'eureka_mse_metal_agent_validation',
    /**
     * 材料性能分析
     */
    eureka_mse_material_agent_validation = 'eureka_mse_material_agent_validation',
    /**
     * 外观FTO分析
     */
    IMAGE_FTO_SEARCH_CODE = 'analytics_ai_image_search_agent_basic_limit',

    /**
     * 生物医药——原研药查询
     */
    eureka_ls_agent_innovator_drug_quick_search = 'eureka_ls_agent_innovator_drug_quick_search',

    /**
     * 生物医药——PCC
     */
    eureka_ls_agent_patent_preclinical_candidate_compound = 'eureka_ls_agent_patent_preclinical_candidate_compound',

    /**
     * 生物医药——立项报告
     */
    eureka_ls_agent_initiate_project = 'eureka_ls_agent_initiate_project',

      /**
     * 监控技术简报
     */
    eureka_pt_ai_agent_create_tech_monitor = 'eureka_pt_ai_agent_create_tech_monitor',

    /**
     * 新颖性检查
     */
    eureka_mse_novel_check = 'eureka_mse_novel_check',
    /**
     * 监控公司技术简报
     */
    eureka_pt_ai_agent_create_company_tech_monitor = 'eureka_pt_ai_agent_create_company_tech_monitor'

}
